import { configureStore, combineReducers } from '@reduxjs/toolkit';
import accountReducer from '../features/account/accountSlice';
import assetReducer from '../features/asset/assetSlice';
import portfolioReducer from '../features/portfolio/portfolioSlice';
import transactionReducer from '../features/transaction/transactionSlice';
import marketsReducer from '../features/markets/marketsSlice';
import userTradeSignalsReducer from '../features/userTradeSignals/userTradeSignalsSlice';
import visualStrategiesReducer from '../features/visualStrategies/visualStrategiesSlice';
import customEventsReducer from '../features/customEvents/customEventsSlice';
import customEventSymbolsReducer from '../features/customEventSymbols/customEventSymbolsSlice';
import strategySymbolsReducer from '../features/strategySymbols/strategySymbolsSlice';
import backtestsReducer from '../features/backtests/backtestsSlice';
import tradesReducer from '../features/trades/tradesSlice';
import executionsReducer from '../features/trades/executionsSlice';
import tradeNotesReducer from '../features/trades/tradeNotesSlice';
import userSettingsReducer from '../features/userSettings/userSettingsSlice';
import evaluationsReducer from '../features/evaluations/evaluationsSlice';
import disclaimerReducer from '../features/disclaimer/disclaimerSlice';
import permissionsReducer from '../features/permissions/permissionsSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import fsmReducer from '../features/fsm/fsmSlice';
import { RESET_STATE } from './resetActions';

// ✅ Properly combine reducers
const combinedReducer = combineReducers({
  account: accountReducer,
  asset: assetReducer,
  portfolio: portfolioReducer,
  transaction: transactionReducer,
  markets: marketsReducer,
  userTradeSignals: userTradeSignalsReducer,
  visualStrategies: visualStrategiesReducer,
  customEvents: customEventsReducer,
  customEventSymbols: customEventSymbolsReducer,
  strategySymbols: strategySymbolsReducer,
  backtests: backtestsReducer,
  trades: tradesReducer,
  executions: executionsReducer,
  tradeNotes: tradeNotesReducer,
  userSettings: userSettingsReducer,
  evaluations: evaluationsReducer,
  disclaimer: disclaimerReducer,
  permissions: permissionsReducer,
  notifications: notificationsReducer,
  fsm: fsmReducer,
});

// ✅ Wrap combinedReducer in a function to handle RESET_STATE
const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined; // ✅ Clears all Redux state
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
